module.exports = __webpack_public_path__ + "img/el-out50.9e2b10c1.png";